import React from 'react'
import FollowUp from '../../components/User/FollowUp'
import Layout from './Layout'

export default function FollowUpPage() {
  return (
    <Layout><FollowUp /></Layout>
  )
}
